var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"warning",staticStyle:{"font-weight":"600","font-size":"20px","display":"block","margin":"0"}},[_vm._v(" "+_vm._s(_vm.countdown)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }